import axios from './configObra/config-obra'

const defaultRoute = '/insumos'
const buscaInsumos = '/busca'
const search = '/busca/filter?'

export default {
  list: () => axios.get(`${defaultRoute}`),
  listByPage: (page, filter, filial) =>
    axios.get(`${defaultRoute}/?limit=10&skip=${page}&${filter}=${filial}`),
  create: (insumo) => axios.post(defaultRoute, insumo),
  createKit: (kit) => axios.post(`${defaultRoute}/kit`, kit),
  updateQuantityMinimum: async (id, estoqueBaixo) =>
    axios.patch(`${defaultRoute}/quantity/${id}`, { estoqueBaixo }),
  updateAutomaticStock: async (id, estoqueBaixoAutomatico) =>
    axios.patch(`${defaultRoute}/estoqueBaixoAutomatico/${id}`, {
      estoqueBaixoAutomatico,
    }),
  update: (id, insumo) => axios.patch(`${defaultRoute}/${id}`, insumo),
  remove: (id) => axios.delete(`${defaultRoute}/${id}`),
  buscaCodigo: (codigo, type, filter, filial, obra = false) =>
    axios.get(
      `${defaultRoute}${buscaInsumos}/${codigo}/${type}?${filter}=${filial}&obra=${obra}`
    ),
  buscaNome: (nome, filter, filial) =>
    axios.get(`${defaultRoute}${search}name=${nome}&${filter}=${filial}`),
  buscaQrCode: (codigos, filter, filial) =>
    axios.post(`${defaultRoute}/lista?${filter}=${filial}`, codigos),

  buscaCod: async (codigo, empresa, filial) => {
    if (filial && empresa) {
      return axios.get(
        `${defaultRoute}/find-by-code/${codigo}?empresa=${empresa}&filial=${filial}`
      )
    }

    if (empresa) {
      return axios.get(`${defaultRoute}/find-by-code/${codigo}?${empresa}`)
    }

    return axios.get(`${defaultRoute}/find-by-code/${codigo}`)
  },
}
